import { InfiniteSearchSelect, SelectProps } from '../../common/components';
import { useInfiniteSearchClassifierMappingsQuery } from '../query/useInfiniteSearchClassifierMappingsQuery';

export interface ClassifierAutoCompleteProps extends SelectProps {
  selectedMapping?: string;
}

export function ClassifierMappingAutoComplete(
  props: ClassifierAutoCompleteProps,
) {
  const { selectedMapping, ...rest } = props;

  return (
    <InfiniteSearchSelect
      {...rest}
      searchOptions={{ selectedMapping }}
      useSearchHook={useInfiniteSearchClassifierMappingsQuery}
    />
  );
}
